import { IconValue } from "@cmp-src/icons";
import * as mdiIcons from "@mdi/js";
import React, { HTMLProps } from "react";
import { LucideIcon, LucideIconName } from "../LucideIcon";
import * as TacticIcons from "../tactic-icons";

export const IconFromSet: React.FC<{
  icon: IconValue | React.FC | null;
  size?: number;
  color?: string;
  style?: React.SVGProps<SVGSVGElement>["style"];
  preserveAspectRatio?: React.SVGProps<SVGSVGElement>["preserveAspectRatio"];
}> = ({ icon, size = 8, color, style, preserveAspectRatio }) => {
  if (!icon) return null;

  if (typeof icon === "object" && !("set" in icon)) {
    const IconComponent = icon as React.FC<HTMLProps<HTMLDivElement>>;
    return (
      <IconComponent
        style={{
          width: size * 4,
          height: size * 4,
          ...style
        }}
      />
    );
  }

  if (typeof icon !== "object" && (!("set" in icon) || !("icon" in icon))) {
    return null;
  }

  const { icon: iconName, set } = icon;

  if (set === "mdi")
    return (
      // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={"0 0 24 24"}
        width={`${style?.width || size * 4}px`}
        height={`${style?.height || size * 4}px`}
        fill={"none"}
        strokeWidth={2}
        style={style}
        preserveAspectRatio={preserveAspectRatio}
      >
        <path
          d={mdiIcons[iconName as never]}
          style={{ fill: color || "currentColor" }}
        />
      </svg>
    );
  if (set === "lucide")
    return (
      <LucideIcon
        name={iconName as LucideIconName}
        size={size}
        color={color}
        style={style}
        preserveAspectRatio={"none"}
      />
    );
  if (set === "tactic" && (iconName as string) in TacticIcons) {
    const IconComponent = TacticIcons[iconName as keyof typeof TacticIcons];
    return (
      <IconComponent
        style={{
          width: size * 4,
          height: size * 4,
          color: color || "currentColor",
          fill: color || "currentColor",
          ...style
        }}
        width={style?.width || size * 4}
        height={style?.height || size * 4}
        preserveAspectRatio={preserveAspectRatio || "xMidYMid meet"}
      />
    );
  }
  //if (set === "custom") return <CustomIcon id={iconName} size={size * 4} />;
  return null;
};
